module.exports = __webpack_public_path__ + "static/media/PaymentOnboardingProcessing.9225f4df.svg";